export default {
  toggleSlideShow(state) {
    state.isToggle = ! state.isToggle
  },

  updateArtworks (state, artworks) {
    state.artworks = artworks
  },

  updateCurrentArtwork (state, selected) {
    state.artworkCounter = selected
  }
}
